module.exports = __webpack_public_path__ + "static/media/pranjal.d7d4ed4c.JPG";